export default __webpack_public_path__ + "static/media/ready.ad780d80.svg";